import { FunctionComponent } from "react";
import { Footer } from "@App/Layouts/Footer";
import { Outlet } from "react-router-dom";
import { NavbarDL } from "@App/Components/NavbarDL";

export const Layout: FunctionComponent = () => {
  return (
    <div className="text-neutral-900">
      <NavbarDL>
        <div className={"flex items-center gap-4"}>
          <a
            href={"https://werkstatt.repareo.de/partner/deutsche-leasing"}
            className={"flex"}
            title={"repareo Werkstattvergleich"}
          >
            <img src="/images/brand/logoBlack.svg" className="w-28 h-auto" alt="" />
          </a>
          <a
            href="http://www.deutsche-leasing.com/"
            title="Deutsche Leasing"
            target="_blank"
            className={"px-2 md:px-4"}
          >
            <img
              src="/images/brand/deutsche-leasing-cooperation.png"
              className={"h-10"}
              alt="Deutsche Leasing"
            />
          </a>
        </div>
      </NavbarDL>
      <Outlet />
      <Footer />
    </div>
  );
};
